import { CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { OrphanEdit } from '.';
import { BrandKey } from '../../../__generated__/queries-web';
import { useGetOrphanById } from '../graphql/getOrphanPage.web.graphql';
interface editPageParams {
  brandKey: BrandKey;
  id: string;
}

export const EditOrphanPage = () => {
  const { brandKey, id } = useParams<editPageParams>();
  const { data, loading } = useGetOrphanById(id);
  if (loading) return <CircularProgress />;
  const {
    status,
    title,
    uri,
    metas,
    content,
    isCMPEnabled,
    isAdsEnabled,
    isFullScreen,
    publishedAt,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  } = data!.orphanPage!;
  return (
    <OrphanEdit
      defaultState={{
        brandKey,
        id,
        status,
        title,
        publishedAt,
        content: content || '',
        url: uri || '',
        metas: metas || [],
        isCMPEnabled: isCMPEnabled || false,
        isAdsEnabled: isAdsEnabled || false,
        isFullScreen: isFullScreen || false,
      }}
    />
  );
};
